export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      files: [
        {
          fileId: 33,
          fileUuid: "files033",
          fileName: "pdf01.pdf",
          fileUri: "/pdf/pdf01.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 32,
          fileUuid: "files032",
          fileName: "pdf02.pdf",
          fileUri: "/pdf/pdf02.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 31,
          fileUuid: "files031",
          fileName: "pdf03.pdf",
          fileUri: "/pdf/pdf03.pdf",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        }
      ]
    }
  }
}